import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function lockChildInfo(id: number) {
  return restApiClient.url(constructApiUrl(API.enrollments.lockChildInfo.url, { id })).post()
}

export function lockIdentityPapers(id: number) {
  return restApiClient.url(constructApiUrl(API.enrollments.lockIdentityPapers.url, { id })).post()
}

export function lockHealthPapers(id: number) {
  return restApiClient.url(constructApiUrl(API.enrollments.lockHealthPapers.url, { id })).post()
}

export function lockPickup(id: number) {
  return restApiClient.url(constructApiUrl(API.enrollments.lockPickup.url, { id })).post()
}

export function lockIdentityPicture(id: number) {
  return restApiClient.url(constructApiUrl(API.enrollments.lockIdentityPicture.url, { id })).post()
}

export function lockLanguageTest(id: number) {
  return restApiClient.url(constructApiUrl(API.enrollments.lockLanguageTest.url, { id })).post()
}

export function unlockChildInfo(id: number) {
  return restApiClient.url(constructApiUrl(API.enrollments.unlockChildInfo.url, { id })).post()
}

export function unlockIdentityPapers(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.unlockIdentityPapers.url, { id }))
    .post()
}

export function unlockHealthPapers(id: number) {
  return restApiClient.url(constructApiUrl(API.enrollments.unlockHealthPapers.url, { id })).post()
}

export function unlockPickup(id: number) {
  return restApiClient.url(constructApiUrl(API.enrollments.unlockPickup.url, { id })).post()
}

export function unlockIdentityPicture(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.unlockIdentityPicture.url, { id }))
    .post()
}

export function unlockLanguageTest(id: number) {
  return restApiClient.url(constructApiUrl(API.enrollments.unlockLanguageTest.url, { id })).post()
}
